import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { message } from 'ant-design-vue';
import { awaitWrap, OK } from '@/common';
import { batchFinishWechatComplaint, batchRefundWechatComplaint, batchReplyWechatComplaint, finishWechatComplaint, replyWechatComplaint, resendWechatComplaintOrder, submitWechatComplaintRefund } from '@/api/wechatComplaint';
export const isOkResponse = res => (res === null || res === void 0 ? void 0 : res.code) === OK || (res === null || res === void 0 ? void 0 : res.code) === '0000' || (res === null || res === void 0 ? void 0 : res.code) === 200 || (res === null || res === void 0 ? void 0 : res.code) === '200';
export const useComplaintActions = ({
  currentComplaint,
  selectedRows,
  selectedRowKeys,
  refresh,
  refreshDetail
}) => {
  const submitLoading = ref(false);
  const reply = async (content, imageMediaIds) => {
    if (!currentComplaint.value) return false;
    submitLoading.value = true;
    const [, res] = await awaitWrap(replyWechatComplaint({
      complaintMainId: currentComplaint.value.complaintMainId,
      content,
      imageMediaIds
    }));
    submitLoading.value = false;
    if (!isOkResponse(res)) return false;
    message.success('回复成功');
    refresh();
    refreshDetail();
    return true;
  };
  const resend = async () => {
    if (!currentComplaint.value) return false;
    const [, res] = await awaitWrap(resendWechatComplaintOrder({
      complaintMainId: currentComplaint.value.complaintMainId
    }));
    if (!isOkResponse(res)) return false;
    message.success('复送成功');
    await refreshDetail();
    await refresh();
    return true;
  };
  const refund = async (amount, reason, screenshotUrls = []) => {
    if (!currentComplaint.value) return false;
    submitLoading.value = true;
    const [, res] = await awaitWrap(submitWechatComplaintRefund({
      complaintMainId: currentComplaint.value.complaintMainId,
      refundAmount: String(amount),
      refundReason: reason,
      customerComplaintUrl: screenshotUrls.join(',')
    }));
    submitLoading.value = false;
    if (!isOkResponse(res)) return false;
    message.success('已提交退款审批');
    refresh();
    refreshDetail();
    return true;
  };
  const rejectRefund = async reason => {
    if (!currentComplaint.value) return false;
    submitLoading.value = true;
    const [, res] = await awaitWrap(finishWechatComplaint({
      complaintMainId: currentComplaint.value.complaintMainId,
      completeReason: reason
    }));
    if (!isOkResponse(res)) {
      submitLoading.value = false;
      return false;
    }
    message.success('处理完成');
    await refreshDetail();
    await refresh();
    submitLoading.value = false;
    return true;
  };
  const batchSubmit = async (type, params, rows) => {
    // 显式区分"未传 rows"和"传了空数组"：传空就提交空（由下方 items.length 兜底拒绝），不再回退到全量勾选
    const source = rows !== null && rows !== void 0 ? rows : selectedRows.value;
    const items = source.map(item => ({
      complaintMainId: item.complaintMainId,
      ...(type === 'refund' && params.mode === 'RATIO' && item.amount ? {
        refundAmount: String(item.amount)
      } : {})
    }));
    if (!items.length) return false;
    const apiMap = {
      refund: batchRefundWechatComplaint,
      reply: batchReplyWechatComplaint,
      finish: batchFinishWechatComplaint
    };
    submitLoading.value = true;
    const [, res] = await awaitWrap(apiMap[type]({
      ...params,
      clientBatchId: `wc-${Date.now()}`,
      items
    }));
    submitLoading.value = false;
    if (!isOkResponse(res)) return false;
    message.success('批量操作成功');
    selectedRowKeys.value = [];
    selectedRows.value = [];
    refresh();
    return true;
  };
  return {
    submitLoading,
    reply,
    resend,
    refund,
    rejectRefund,
    batchSubmit
  };
};